export default __webpack_public_path__ + "static/media/downtrendgraph.85f50d6e.png";